import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import './subscription.css';
import medic from '../../assets/images/Medic.png';
import { FaArrowDown, FaEdit } from "react-icons/fa";
import { motion } from 'framer-motion';
import api from '../../service/caller';
import { ToastContainer, toast } from 'react-toastify';
import logomedtinz from '../../assets/images/MedTinz.png';
import imageOrangeTopLeft from '../../assets/images/Medic symbol circle.png';
import imageOrangeBottomLeft from '../../assets/images/Checklist.png';
import Pil from '../../assets/images/Pil.png';
import Dna from '../../assets/images/DNA.png';

const Subscription = () => {
  const location = useLocation();
  const hospital_admin_id = location.state;

  const [subscriptions, setSubscriptions] = useState([]);
  const [features, setFeatures] = useState([]);
  const [selectedPlan, setSelectedPlan] = useState(null);
  const [showAll, setShowAll] = useState(false);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const [durationValue, setDurationValue] = useState(1);
  const [totalPrice, setTotalPrice] = useState(0); // Valeur initiale du total

  // Calcul du prix total
  const calculateTotalPrice = () => {
    // Calcul du total pour chaque feature
    const calculatedTotal = customFeatures.reduce((total, feature) => {
      const originalFeature = features.find(f => f._id === feature.featureId);
      // Utiliser (feature.quantity || 1) pour être cohérent avec l'affichage
      return total + ((feature.quantity || 1) * originalFeature.price);
    }, 0);

    // Multiplier par la durée après avoir calculé le total des features
    const finalTotal = (calculatedTotal * durationValue).toFixed(2);
    setTotalPrice(finalTotal);
  };


  const handleDurationChange = (e) => {
    const newValue = parseInt(e.target.value) || 0;
    setDurationValue(newValue);
    // Recalculer le prix total après changement de durée
    calculateTotalPrice();
  };

  // Nouveaux états pour la personnalisation
  const [isCustomizing, setIsCustomizing] = useState(false);
  const [customFeatures, setCustomFeatures] = useState([]);

  const navigate = useNavigate();

  useEffect(() => {
    const fetchSubscriptions = async () => {
      try {
        setLoading(true);
        const { data } = await api.get('/api/subscriptions');
        setSubscriptions(data);
      } catch (err) {
        setError('Erreur lors de la récupération des abonnements.');
        console.error(err);
      } finally {
        setLoading(false);
      }
    };

    fetchSubscriptions();
  }, []);

  useEffect(() => {
    const fetchFeatures = async () => {
      try {
        const { data } = await api.get('/api/getallfeatures');
        setFeatures(data);
        const Editable = data;
        console.log("Edit", Editable)

        // Initialiser les features personnalisables
        setCustomFeatures(Editable.map(feature => ({
          featureId: feature._id,
          name: feature.name,
          quantity: 1
        })));
      } catch (err) {
        setError('Erreur lors de la récupération des fonctionnalités.');
        console.error(err);
      }
    };

    fetchFeatures();
  }, []);

  useEffect(() => {
    calculateTotalPrice();
  }, [customFeatures, durationValue]); // Recalculer quand les features ou la durée changent


  const toggleShowAll = () => {
    setShowAll(!showAll);
  };

  const handleChoose = async (subscription) => {
    try {
      // Envoi des données à la route POST
      const hospitalSpecIdGet = await getHospitalsByAdmin(hospital_admin_id);  // Attendez la réponse avant d'envoyer
      await api.post('/api/selectplan', { subscription_id: subscription._id, hospitalSpecId: hospitalSpecIdGet });

      // Redirection après succès
      navigate(`/plan/${subscription._id}`);
    } catch (err) {
      console.error('Erreur lors de la soumission du plan :', err);
      setError('Une erreur est survenue lors de la sélection du plan.');
    }
  };

  const handleCustomFeatureChange = (featureId, quantity) => {
    setCustomFeatures(prev =>
      prev.map(f =>
        f.featureId === featureId
          ? { ...f, quantity: Math.max(0, quantity) } // Minimum 1 au lieu de 0
          : f
      )
    );
  };

  const handleCreateCustomPlan = async () => {
    try {
      // Filtrer les features avec une quantité > 0
      const selectedFeatures = customFeatures
        .filter(f => f.quantity > 0)
        .map(f => ({
          featureId: f.featureId,
          quantity: f.quantity
        }));

      const hospitalSpecIdGet = await getHospitalsByAdmin(hospital_admin_id);

      const dataToSend = {
        hospitalSpecId: hospitalSpecIdGet,
        features: selectedFeatures,
        planDuration: durationValue,
        planPrice: totalPrice,
        planEndDate: ''
      }
      const response = await api.post('/api/customize-subscription', dataToSend);

      // console.log(response?.data?.plan);
      // console.log(dataToSend);


      // Naviguer vers la page de détail du plan personnalisé
      if (response.status === 200 || response.status === 201) {
        navigate(`/planPersonalized/${response?.data?.plan?._id}`);
      } else {
        alert('');
      }
    } catch (err) {
      // console.error('Erreur lors de la création du plan personnalisé:', err?.response?.data?.message);
      toast.error(err?.response?.data?.message);
      setError('Une erreur est survenue lors de la création du plan.');
    }
  };

  const getHospitalsByAdmin = async (hospitalAdminId) => {
    try {
      const responseHospital = await api.get(`/api/hospitals/admin/${hospitalAdminId}`);

      if (responseHospital.data && responseHospital.data.length > 0) {
        const hospital = responseHospital.data[0];
        return hospital.hospital_spec_id;
      } else {
        toast.error("Aucun hôpital trouvé");
        return null;
      }
    } catch (error) {
      // console.error('Error fetching hospital:', error?.response?.data?.message);
      toast.error(error?.response?.data?.message);
      return null;
    }
  };

  const toggleCustomization = () => {
    setIsCustomizing(!isCustomizing);
  };

  // Reste du code du composant précédent...

  return (
    <div className="subscription-container">
      <ToastContainer />
      {/* <motion.div
        initial={{ x: '-100vw' }}
        animate={{ x: 0 }}
        exit={{ x: '100vw' }}
        transition={{ duration: 0.5 }}
      > */}
      {/* Contenu précédent... */}
      <div className="microbe position-relative">
        <section className='py-5 position-relative' style={{ background: '#0056B3' }}>
          <div className='container mt-5'>
            <div className='row text-center'>
              <div className='col-lg-3 mb-3'>
                <div className='mt-2'>
                  <img src={logomedtinz} alt="Bottom left orange" className="logomedtinz" />
                </div>
              </div>
              <div className='col-lg-6 mb-3'>
                <h2 className='text-white text-center' style={{ fontSize: '45px', fontFamily: 'Inter,sans-serif', fontWeight: '600' }}>
                  Choose the right  medical subscription for you
                </h2>
              </div>
              <div className='col-lg-3'></div>
            </div>
            <div className='d-flex justify-content-center'>
              <div style={{ width: '66%' }}>
                <p className='text-center text-white'>Choose the plan that’s right for your business. Whether you’re just getting started with email marketing or well down the path to personalization, we’re got you covered</p>
              </div>
            </div>
          </div>
          <div style={{ position: 'absolute', right: '0', top: '0' }}>
            <img src={imageOrangeTopLeft} />

          </div>
          <div style={{ position: 'absolute', left: '0', bottom: '-5rem' }}>
            <img src={imageOrangeBottomLeft} />
          </div>
        </section>

        {/* Bouton de personnalisation */}
        <div className="text-center my-3">
          <button
            className="btn btn-primary"
            onClick={toggleCustomization}
          >
            <FaEdit /> {isCustomizing ? 'Back to plans' : 'Customize a plan'}
          </button>
        </div>

        {/* Vue de personnalisation */}
        {isCustomizing && (
          <div className="container mb-4 pb-4">
            <h3>Customize your plan</h3>

            <tr key={'duration'} className='m-4 p-2'>
              <td>Duration</td>
              <td>Monthly</td>
              <td>
                <input
                  type="number"
                  name="duration"
                  id="duration"
                  min="1"
                  value={durationValue}
                  onChange={handleDurationChange}
                  className="form-control"
                />
              </td>
              <td>
                {/* {durationValue}  */}
                Months
              </td>
            </tr>

            <table className="table">
              <thead>
                <tr>
                  <th>Features</th>
                  <th>Unit price</th>
                  <th >Quantity</th>
                  <th>Total</th>
                </tr>
              </thead>
              <tbody>
                {customFeatures.map(feature => {
                  const originalFeature = features.find(f => f._id === feature.featureId);
                  console.log("Opii", originalFeature);
                  return (
                    <tr key={feature.featureId}>
                      <td className="reve">{feature.name}</td>
                      <td>{originalFeature.price} XOF </td>
                      <td >
                        <select
                          value={feature.quantity}
                          onChange={(e) =>
                            handleCustomFeatureChange(feature.featureId, parseInt(e.target.value))
                          }
                          className="form-control"
                        >
                          <option value={1}>Included</option>
                          <option value={0}>Not included</option>
                        </select>
                      </td>
                      <td>
                        {((feature.quantity) * originalFeature.price).toFixed(2)} cfa
                      </td>
                    </tr>
                  );
                })}
              </tbody>
              <tfoot>
                <tr>
                  <td colSpan="3">Total price</td>
                  <td>
                    {totalPrice} XOF
                  </td>
                </tr>
              </tfoot>
            </table>
            <button
              className="btn btn-success text-white"
              onClick={handleCreateCustomPlan}
            >
              Create my personalized plan
            </button>
          </div>
        )}

        {/* Reste du tableau des abonnements... */}
        {!isCustomizing && (
          <div className="container">
            <div className="mt-4 mb-5">
              <table className="table table-bordered">
                <thead>
                  <tr>
                    <th className="hidden-th">Features</th>
                    {subscriptions.map((subscription, index) => (
                      <th key={index}>
                        <p onClick={() => setSelectedPlan(subscription.name)}>
                          {subscription.type}
                          <br />
                          <span className="trip">XOF{subscription.price}</span>
                          <span className="solo">/ {subscription.duration} month</span>
                        </p>
                      </th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  {features.map((feature, index) => (
                    <tr key={index} style={{ backgroundColor: index % 2 === 0 ? '#28A74582' : 'white' }}>
                      <td className="reve">{feature.name}</td>
                      {subscriptions.map((subscription) => {
                        const featureValue = subscription.features[index];
                        const valueToDisplay = featureValue;
                        console.log("Pla", valueToDisplay);

                        return (
                          <td
                            key={subscription._id}
                            className={`rive ${selectedPlan === subscription.name ? 'selected' : ''}`}
                          >
                            {valueToDisplay?.value === "true" ? '✔' : (valueToDisplay?.value === "false" || !valueToDisplay) ? '−' : valueToDisplay}
                          </td>
                        );
                      })}
                    </tr>
                  ))}
                </tbody>
                <tfoot>
                  <tr>
                    <td>
                      <button
                        className="btn btn-link more-info-btn"
                        onClick={toggleShowAll}
                      >
                        {/* <FaArrowDown /> {showAll ? ' CLICK TO VIEW MORE FEATURES' : ' CLICK TO VIEW MORE FEATURES'} */}
                      </button>
                    </td>
                    {subscriptions.map((subscription, index) => (
                      <td key={index}>
                        <button
                          className="choose-btn"
                          onClick={() => handleChoose(subscription)}
                        >
                          Choose
                        </button>
                      </td>
                    ))}
                  </tr>
                </tfoot>
              </table>
            </div>
          </div>
        )}

        <div className='container'>
          <div><img src={Pil} className='img-fluid' /></div>
          <div className='d-none d-lg-block'><img src={Dna} className='img-fluid pil' /></div>
        </div>
      </div>
      {/* </motion.div> */}
    </div>
  );
};

export default Subscription;